import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { Accordion, Form, Row, Col, Collapse, Button, Modal, Table } from "react-bootstrap";
import CombosAnidados from "../../components/combosAnidados/combosAnidadosTomo1";
import { INFO, ALERT_ERROR } from "../../components/iconsSVG/IconsSVG";
import {
  getModalidadesTomo1,
} from "../../services/sumarioService";
import { getBuscarAnotaciones, getBuscarAnotacionesTotales } from '../../services/buscarTomos';
import { buscarNiza } from '../../services/buscarTomos';
import { buscarViena } from '../../services/buscarTomos';
import BusquedaTomos from "./components/botonesBusquedaTomos";
import "./buscadorAvanzado.css"
import DropDownBuble from "../../components/dropdownbuble/DropDownBuble";
// import { AlertComp } from "../FormularioPage/components/alert/alertComp";

import { useAlert } from "../../context/AlertContext";

  const BuscadorAvanzadoTomo1 = forwardRef(({ onResultados, setCargando1, setBusquedaRealizada1, onSearchData, resultadosTotales }, ref) => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  const [showModalModalidades, setShowModalModalidades] = useState(false);
  const handleCloseModalModalidades = () => setShowModalModalidades(false);
  const handleShowModalModalidades = () => setShowModalModalidades(true);

  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [numeroSolicitud, setNumeroSolicitud] = useState("");
  const [fechaPublicacionDesde, setFechaPublicacionDesde] = useState("");
  const [fechaPublicacionHasta, setFechaPublicacionHasta] = useState("");
  const [solicitanteTitular, setSolicitanteTitular] = useState("");
  const [agenteRepresentante, setAgenteRepresentante] = useState("");
  const [codigoAgente, setCodigoAgente] = useState("");
  const [recurrente, setRecurrente] = useState("");
  const [denominacion, setDenominacion] = useState("Contenga");
  const [denominacionTexto, setDenominacionTexto] = useState("");
  const [numeroPrioridad, setNumeroPrioridad] = useState("");
  const [productosServicios, setProductosServicios] = useState("");
  const [clasificacionNiza, setClasificacionNiza] = useState("");
  const [elementoFigurativo, setElementoFigurativo] = useState("");
  const [clasificacionViena1, setClasificacionViena1] = useState("");
  const [clasificacionViena2, setClasificacionViena2] = useState("");
  const [clasificacionViena3, setClasificacionViena3] = useState("");
  const [modalidades, setModalidades] = useState([]);
  const [selectedModalidadId, setSelectedModalidadId] = useState("");

  const combosAnidadosRef = React.createRef();
  const [capitulo, setCapitulo] = useState("");
  const [subcapitulo, setSubcapitulo] = useState("");
  const [apartado, setApartado] = useState("");
  const [subapartado, setSubapartado] = useState("");
  const [ley, setLey] = useState("");
  const inputRefDesde = useRef(null);
  const inputRefHasta = useRef(null);

  const [accordionKey, setAccordionKey] = useState("1");

  // const [mostrarAlert, setmostrarAlert] = useState(false);
  // const [tipo, setTipo] = useState("");
  // const [titulo, setTitulo] = useState("");
  // const [msg, setMsg] = useState("");
  // const [customIcon, setCustomicon] = useState(null);

  // const handleCloseAlert = () => {
  //   setmostrarAlert(false);
  // };

  const toggleFilters = () => {
    setOpen(!open);
  };

  const limpiarCampos = () => {
    
    if (combosAnidadosRef.current) {
      combosAnidadosRef.current.resetCapituloId();
      combosAnidadosRef.current.resetSubcapituloId();
      combosAnidadosRef.current.resetApartadoId();
      combosAnidadosRef.current.resetSubapartadoId();
      setBusquedaRealizada1(false)
    }
    
    setTextoBusqueda("");
    setNumeroSolicitud("");
    setFechaPublicacionDesde("");
    setFechaPublicacionHasta("");
    setSolicitanteTitular("");
    setAgenteRepresentante("");
    setCodigoAgente("");
    setRecurrente("");
    setDenominacion("");
    setDenominacionTexto("");
    setNumeroPrioridad("");
    setProductosServicios("");
    setClasificacionNiza("");
    setElementoFigurativo("");
    setClasificacionViena1("");
    setClasificacionViena2("");
    setClasificacionViena3("");
    setSelectedModalidadId("");
    setSelectedNizaClasses("");
    setSearchNizaText("");
    setSelectedVienaClasses([]);
    setSearchVienaText("");
    // setmostrarAlert(false);

    closeAlert();

    // setCargando1(false);

  };

  useImperativeHandle(ref, () => ({
    limpiarCampos: limpiarCampos,
  }));

  /* Cosas buscador. */
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  // Estados y funciones para el buscador de Niza
  const [searchPopupVisible, setSearchPopupVisible] = useState(false);
  const [searchText, setSearchNizaText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedClasses, setSelectedNizaClasses] = useState([]);
  const [resultadosNiza, setResultadosNiza] = useState([]);
  const [resultadosViena, setResultadosViena] = useState([]);

  const handleSearchPopupClose = () => setSearchPopupVisible(false);

  const handleSearchPopupShow = async (e) => {
    const resultadoBusquedaNiza = await buscarNiza();
    setSearchPopupVisible(true);

    const results = Object.entries(resultadoBusquedaNiza).map(([clase, string]) => ({
      clase: clase,
      string: string
    })).sort((a, b) => {
      return parseInt(a.clase, 10) - parseInt(b.clase, 10);
    });

    setSearchResults(results);
    setResultadosNiza(results);
  }


  const handleSearchNizaChange = async (e) => {

    const searchTerm = e.target.value;
    setProductosServicios(searchTerm);
    setSearchNizaText(searchTerm);

    const filteredResults = resultadosNiza.filter((result) => {
      return result.string.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setSearchResults(filteredResults);

  };


  const handleCheckboxNizaChange = (clase) => {
    setSelectedNizaClasses((prevSelected) => {
      const newSelected = prevSelected.includes(clase)
        ? prevSelected.filter((item) => item !== clase)
        : [...prevSelected, clase];
  
      return newSelected.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    });
  };
  

  const handleSearchNizaSelect = () => {
    setClasificacionNiza(selectedClasses.join(", "));
    setProductosServicios(searchText);
    setSearchPopupVisible(false);
  };


  // Estados y funciones para el buscador de Viena
  const [searchVienaPopupVisible, setSearchVienaPopupVisible] = useState(false);
  const [searchVienaText, setSearchVienaText] = useState("");
  const [searchVienaResults, setSearchVienaResults] = useState([]);
  const [selectedVienaClasses, setSelectedVienaClasses] = useState([]);

  const handleSearchVienaPopupClose = () => setSearchVienaPopupVisible(false);


  const handleSearchVienaPopupShow = async (e) => {
    const resultadoBusquedaViena = await buscarViena();

    const results = Object.entries(resultadoBusquedaViena).map(([clase, string]) => ({
      clase: clase,
      string: string
    })).sort((a, b) => {
      return parseInt(a.clase, 10) - parseInt(b.clase, 10);
    });

    setSearchVienaPopupVisible(true);
    setSearchVienaResults(results);
    setResultadosViena(results);
  }

  const handleSearchVienaChange = async (e) => {

    const searchTerm = e.target.value;
    setElementoFigurativo(e.target.value);
    setSearchVienaText(e.target.value);

    const filteredResults = resultadosViena.filter((result) => {
      return result.string.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setSearchVienaResults(filteredResults);
  };


  const handleCheckboxVienaChange = (clase) => {
    setSelectedVienaClasses([clase]);
  };

  const handleSearchVienaSelect = () => {
    const selectedClass = selectedVienaClasses[0];

    if(selectedClass){
      const ClasVienaArray = selectedClass.split(" ");

      setClasificacionViena1(ClasVienaArray[0]);
      setClasificacionViena2(ClasVienaArray[1]);
      setClasificacionViena3(ClasVienaArray[2]);
      setElementoFigurativo(searchVienaText);
    }
    setSearchVienaPopupVisible(false);
  };


  useEffect(() => {
    const fetchModalidades = async () => {
      const modalidadesList = await getModalidadesTomo1();
      const arrayTransformado = Object.entries(modalidadesList || {}).map(([id, displayName]) => ({
        id: parseInt(id, 10), // Aseguramos que el ID sea un número
        displayName,
      }));
      setModalidades(arrayTransformado);
      setSelectedModalidadId("");
    };
    fetchModalidades();
  }, []);

  const handleCombosAnidadosT1 = (capitulo, subcapitulo, apartado, subapartado) => {
    setCapitulo(capitulo);
    setLey("");
    setSubcapitulo(subcapitulo);
    setApartado(apartado);
    setSubapartado(subapartado);
  };

  const { showAlert } = useAlert();
  const { closeAlert } = useAlert();

  const handleSearchT1 = () => {

    const searchData = {
      tomo: 1,
      textoBusqueda,
      numeroSolicitud,
      fechaPublicacionDesde,
      fechaPublicacionHasta,
      solicitanteTitular,
      agenteRepresentante,
      codigoAgente,
      recurrente,
      denominacion,
      denominacionTexto,
      numeroPrioridad,
      productosServicios,
      clasificacionNiza,
      elementoFigurativo,
      selectedVienaClasses,
      selectedModalidadId,
      capitulo,
      subcapitulo,
      apartado,
      subapartado,
      ley
    };

    if (textoBusqueda == "" && numeroSolicitud == "" && fechaPublicacionDesde == "" && fechaPublicacionHasta == "" && 
      solicitanteTitular == "" && agenteRepresentante == "" && codigoAgente == "" && 
      recurrente == "" && denominacionTexto == "" && numeroPrioridad == "" && selectedModalidadId == "" &&
      capitulo == "" && subcapitulo == "" && apartado == "" && subapartado == "" && ley == "" ) {

      //setShow(true);
      // setTipo("error");
      // setTitulo("");
      // setMsg("Se debe introducir al menos un parámetro de búsqueda.");
      
      // setCustomicon(<ALERT_ERROR/>)
      // setmostrarAlert(false);
      // setmostrarAlert(true);

      showAlert({
        tipo: "error",
        titulo: "",
        msg: "Se debe introducir al menos un parámetro de búsqueda.",
        customIcon: <ALERT_ERROR/>
      });

      window.scrollTo(0, 250);
    } else{

      try {
        // setmostrarAlert(false);
        closeAlert();
        setAccordionKey(null);
        setCargando1(true);
        setBusquedaRealizada1(false);
        // Llamada al servicio
        const fetchAnotaciones = async () => {
          onResultados([]);
          resultadosTotales(null);
          await new Promise(resolve => setTimeout(resolve, 2000)); // espero 2 segundos
          const resultadoBusqueda = await getBuscarAnotaciones(searchData, 0, 20, "", 0);
          const totalBusqueda = await getBuscarAnotacionesTotales(searchData);
          onResultados(resultadoBusqueda);
          setBusquedaRealizada1(true);
          setCargando1(false);
          onSearchData(searchData);
          resultadosTotales(totalBusqueda)
        };
        fetchAnotaciones();
      } catch (error) {
        setCargando1(false);
        setBusquedaRealizada1(true); // búsqueda realizada aunque ha habido error
        console.error('Error al hacer la búsqueda: ', error);
      }

    }
  };



  // Referencias para los componentes de búsqueda avanzada

  // const handleRecargarResultados = (tomo, nuevosResultados) => {
  //   if (tomo === "Tomo1") {
  //     setResultadosTomo1(nuevosResultados);
  //   } else if (tomo === "Tomo2") {
  //     setResultadosTomo2(nuevosResultados);
  //   } else if (tomo === "Tomo3") {
  //     setResultadosTomo3(nuevosResultados);
  //   }
  // };



  return (
    <>
      <div className="espacios-generales shadow m-0 p-0">
        
        {/* <button
          className="btn-azul"
          onClick={toggleFilters}
          aria-controls="filtrosCollapse"
          aria-expanded={open}
        > */}

          <Accordion activeKey={accordionKey} onSelect={(k) => setAccordionKey(k)} className="w-100 glob-custom-accordion-button" style={{ zIndex: "3000" }}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Filtros de búsqueda
            </Accordion.Header>
            <Accordion.Body>
              {/* {open ? "Ocultar filtros de búsqueda" : "Mostrar filtros de búsqueda"}
              </Button>
              <Collapse in={open}> */}
              <div id="filtrosCollapse" className="text-start">
                <Form onSubmit={(e) => { e.preventDefault(); handleSearchT1(); }}
                      onKeyDown={(e) => { if (e.key === "Enter") {e.preventDefault(); handleSearchT1(); }}}>
                  {/* { mostrarAlert ? <AlertComp tipo={tipo} titulo={titulo} msg={msg} customIcon={customIcon}></AlertComp> : null } */}
                  {/* {mostrarAlert && (
                    <AlertComp 
                      tipo={tipo} 
                      titulo={titulo} 
                      msg={msg} 
                      customIcon={customIcon}   
                      open={mostrarAlert}
                      onClose={handleCloseAlert}
                    />
                  )} */}
                  <br />
                <p>
                  Puedes buscar cualquier publicación en el Boletín Oficial de la
                  Propiedad Industrial Tomo 1 por los siguientes campos.
                </p>
                <br />

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start">
                        <b>Texto de búsqueda</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Texto de búsqueda"
                        value={textoBusqueda}
                        onChange={(e) => setTextoBusqueda(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Modalidad</b>
                        <Button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          className="m-0 p-0 fondo-blanco-icono info"
                          onClick={() => handleShowModalModalidades()}
                        >
                          <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                        </Button>
                        {/* <Button className="fondo-blanco-icono" onClick={handleShowModalModalidades}>
                          <INFO color_icono="#203C77" color_fondo="white" className="p-0 m-0" />
                        </Button> */}
                        <Modal show={showModalModalidades} onHide={handleCloseModalModalidades}>
                          <Modal.Header closeButton></Modal.Header>
                          <Modal.Body>
                            A la hora de hacer tu consulta, ten en cuenta que la base de datos CEO (accesible desde esta herramienta al hacer click en el icono CEO en la parte derecha del listado de resultados obtenidos) solamente muestra información de las modalidades M-Marca nacional, N-Nombre comercial, H-Marca internacional y R-Rótulo de establecimiento. En caso de que tu consulta se refiera a otra modalidad, el botón de CEO no aparecerá.</Modal.Body>
                        </Modal>
                      </Form.Label>
                      <Form.Select
                        className="mb-3"
                        // as="select"
                        value={selectedModalidadId}
                        onChange={(e) => setSelectedModalidadId(e.target.value)}
                      >
                        <option value="">Seleccione una modalidad</option>
                        {modalidades.map((modalidad) => (
                          <option key={modalidad.id} value={modalidad.id}>
                            {modalidad.displayName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Número de solicitud/registro</b>
                        <Button className="m-0 p-0 fondo-blanco-icono info invisible">
                            <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                        </Button>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Número de solicitud"
                        value={numeroSolicitud}
                        // onChange={(e) => setNumeroSolicitud(e.target.value)}
                        // Se borran espacios al principio y al final
                        onChange={(e) => setNumeroSolicitud(e.target.value.replace(/^\s+|\s+$/g, ''))}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3 text-start">
                  </Row>
                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Fecha publicación desde</b>
                      </Form.Label>
                      <Form.Control
                        ref={inputRefDesde}
                        className="mb-3 date-picker-only"
                        type="date"
                        value={fechaPublicacionDesde}
                        onChange={(e) => setFechaPublicacionDesde(e.target.value)}
                        min="1999-04-01"
                        max={new Date().toISOString().split('T')[0]}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onClick={() => inputRefDesde.current?.showPicker()}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Fecha de publicación hasta</b>
                      </Form.Label>
                      <Form.Control
                        ref={inputRefHasta}
                        className="mb-3 date-picker-only"
                        type="date"
                        value={fechaPublicacionHasta}
                        onChange={(e) => setFechaPublicacionHasta(e.target.value)}
                        min="1999-04-01"
                        max={new Date().toISOString().split('T')[0]}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onClick={() => inputRefHasta.current?.showPicker()}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start text-break">
                        <b>Solicitante/Titular</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Solicitante/Titular"
                        value={solicitanteTitular}
                        onChange={(e) => setSolicitanteTitular(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start text-break">
                        <b>Agente/Representante</b>
                        <Button className="m-0 p-0 fondo-blanco-icono info invisible">
                            <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                        </Button>
                      </Form.Label>
                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Agente/Representante"
                        value={agenteRepresentante}
                        onChange={(e) => setAgenteRepresentante(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Código agente</b>
                          <Button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            className="m-0 p-0 fondo-blanco-icono info"
                            onClick={() => window.open("https://www.oepm.es/es/conoce-la-propiedad-industrial/informacion-general/quienes-pueden-asesorarnos-y-ayudarnos-a-gestionar-los-tramites/buscador-de-agentes/", "_blank", "noopener,noreferrer")}
                          >
                            <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
                          </Button>
                      </Form.Label>                  
                      <Form.Control
                        type="text"
                        placeholder="0000"
                        style={{ width: "10ch"}}
                        value={codigoAgente}
                        onChange={(e) => {
                          const soloNumeros = e.target.value.replace(/\D/g, "").slice(0, 4);
                          setCodigoAgente(soloNumeros)}}
                                                  
                        onBlur={() => {
                          if (codigoAgente) {
                            setCodigoAgente(codigoAgente.padStart(4, "0"));
                          }
                        }}
                      />
                    </Form.Group>

                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={8}>
                      <Form.Label className="text-start">
                        <b>Recurrente</b>
                        <Button className="fondo-blanco-icono" onClick={handleShow}>
                          {/* <INFO color_icono="#203C77" color_fondo="white" className="p-0 m-0" /> */}
                        </Button>
                        <Modal show={show} onHide={handleClose}>
                          <Modal.Header closeButton></Modal.Header>
                          <Modal.Body>Información sobre recurrente</Modal.Body>
                        </Modal>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Recurrente"
                        value={recurrente}
                        onChange={(e) => setRecurrente(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Denominación</b>
                      </Form.Label>
                      <Form.Select
                        className="mb-3"
                        // as="select"
                        value={denominacion}
                        onChange={(e) => setDenominacion(e.target.value)}
                      >
                        <option>Contenga</option>
                        <option>Comience por</option>
                        <option>Acabe en</option>
                        <option>Consista en</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Denominación texto</b>
                      </Form.Label>
                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Denominación texto"
                        value={denominacionTexto}
                        onChange={(e) => setDenominacionTexto(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Nº de prioridad</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Nº de prioridad"
                        value={numeroPrioridad}
                        onChange={(e) => setNumeroPrioridad(e.target.value)}
                      />
                    </Form.Group>
                  </Row>

                  {/* <Row className="mb-3 text-start">
                    <h2 style={{ fontSize: '1.5em' }}>
                      Localizar por clases de Niza
                      <Button className="fondo-blanco-icono" onClick={handleShow}>
                        <INFO color_icono="#203C77" color_fondo="white" className="p-0 m-0" />
                      </Button>
                    </h2>
                    <Modal show={show} onHide={handleClose}>
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>Lorem ipsum</Modal.Body>
                    </Modal>

                    <Form.Group as={Col} xs={12} md={5}>
                      <Form.Label className="text-start">
                        <b>Productos/Servicios (CI.Niza)</b>
                      </Form.Label>

                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Productos y servicios"
                        value={productosServicios}
                        onChange={(e) => {
                          setProductosServicios(e.target.value);
                          handleSearchNizaChange(e);
                        }}
                        onClick={handleSearchPopupShow}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={5}>
                      <Form.Label className="text-start">
                        <b>Clasificación de Niza</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        // placeholder="Clasificación de Niza"
                        value={clasificacionNiza}
                        disabled
                        onChange={(e) => setClasificacionNiza(e.target.value)}
                        className="input-niza"
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 text-start">
                    <h2 style={{ fontSize: '1.5em' }}>
                      Localizar por clases de Viena
                      <Button className="fondo-blanco-icono" onClick={handleShow}>
                        <INFO color_icono="#203C77" color_fondo="white" className="p-0 m-0" />
                      </Button>
                    </h2>
                    <Modal show={show} onHide={handleClose}>
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>Lorem ipsum</Modal.Body>
                    </Modal>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Elemento figurativo</b>
                      </Form.Label>

                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="Elemento figurativo"
                        value={elementoFigurativo}
                        onChange={(e) => {
                          setSearchVienaText(e.target.value);
                          handleSearchVienaChange(e);
                        }}
                        onClick={handleSearchVienaPopupShow}
                      />
                    </Form.Group>

                    <Form.Group as={Col} xs={12} md={4}>
                      <Form.Label className="text-start">
                        <b>Clasificación de Viena</b>
                      </Form.Label>
                      <div className="clasesViena">
                        <Form.Control
                          type="text"
                          // placeholder="Clasificación de Viena"
                          value={clasificacionViena1}
                          disabled
                          onChange={(e) => setClasificacionViena1(e.target.value)}
                          className="input-niza me-1"
                        />
                        <Form.Control
                          type="text"
                          // placeholder="Clasificación de Viena"
                          value={clasificacionViena2}
                          disabled
                          onChange={(e) => setClasificacionViena2(e.target.value)}
                          className="input-niza me-1"
                        />
                        <Form.Control
                          type="text"
                          // placeholder="Clasificación de Viena"
                          value={clasificacionViena3}
                          disabled
                          onChange={(e) => setClasificacionViena3(e.target.value)}
                          className="input-niza"
                        />
                      </div>

                    </Form.Group>
                  </Row> */}

                  <Row className="mb-3 text-start">
                    <Form.Group as={Col} xs={12} md={12}>
                      <CombosAnidados ref={combosAnidadosRef} combosAnidadosT1={handleCombosAnidadosT1} />
                    </Form.Group>
                  </Row>
                  <button type="submit" style={{ display: "none" }} />
                </Form>
              </div>
              {/* </Collapse> */}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>


        {/* Modal para la búsqueda de Niza */}
        <Modal show={searchPopupVisible} onHide={handleSearchPopupClose}>
          <Modal.Header closeButton>
            <Modal.Title>Buscar en Clasificación de Niza</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              value={searchText}
              onChange={handleSearchNizaChange}
            />

            {/* Contenedor para hacer scroll en la tabla */}
            <div className="table-scroll-container">
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr>
                    <th className="bopi-table">Seleccionar</th>
                    <th className="bopi-table">Clase</th>
                    <th className="bopi-table">Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((result, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedClasses.includes(result.clase)}
                          onChange={() => handleCheckboxNizaChange(result.clase)}
                        />
                      </td>
                      <td>{result.clase}</td>
                      <td>{result.string}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-azul" onClick={handleSearchNizaSelect}>
              SELECCIONAR
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal para la búsqueda de Viena */}
        <Modal show={searchVienaPopupVisible} onHide={handleSearchVienaPopupClose}>
          <Modal.Header closeButton>
            <Modal.Title>Buscar en Clasificación de Viena</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              value={searchVienaText}
              onChange={handleSearchVienaChange}
            />

            {/* Contenedor para hacer scroll en la tabla */}
            <div className="table-scroll-container">
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr>
                    <th className="bopi-table">Seleccionar</th>
                    <th className="bopi-table" style={{width: 80}}>Clase</th>
                    <th className="bopi-table">Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {searchVienaResults.map((result, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedVienaClasses.includes(result.clase)}
                          onChange={() => handleCheckboxVienaChange(result.clase)}
                        />
                      </td>
                      <td>{result.clase}</td>
                      <td>{result.string}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-azul" onClick={handleSearchVienaSelect}>
              SELECCIONAR
            </Button>
          </Modal.Footer>
        </Modal>
        {accordionKey === "1" && (
          <div className="d-flex flex-row justify-content-center">
            <BusquedaTomos
              onSearch={handleSearchT1}
              onLimpiarFiltros={limpiarCampos}
            />
            <br />
            <DropDownBuble
              tomo="Tomo1"
              onRecargarResultados={handleSearchT1}
              onLimpiarFiltros={limpiarCampos}
            />
          </div>
        )}

      </div>
      
      <br />
    </>
  );
});

const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
};

export default BuscadorAvanzadoTomo1;
